import {
  forwardRef,
  Component,
  OnInit,
  Inject,
  Input,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Apollo, gql } from 'apollo-angular';
import { showApolloError } from '../../alert';

@Component({
  selector: 'user-role-selector',
  templateUrl: 'new/shared/components/user-role-selector.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR, 
      useExisting: forwardRef(() => UserRoleSelector), 
      multi: true
    }
  ]
})
export class UserRoleSelector implements OnInit {
  @Input() private optional: string;

  private disabled: boolean = false;
  private selected: number = null;
  private items = [];

  private _onTouched: any = () => {}
  private _onChange: any = () => {}

  constructor(@Inject(Apollo) private apollo: Apollo) {}

  private onChange() {
    this._onChange(this.selected);
    this._onTouched();
  }

  writeValue(value: number) {
    this.selected = value;
    this.onChange();
  }

  registerOnChange(fn: () => any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  async ngOnInit() {
    try {
      const { data } = await this.apollo.query<any>({
        query: gql`
          query {
            userRoles {
              allUserRoles {
                label
                value: id
              }
            }
          }
        `
      }).toPromise();
      this.items = data.userRoles.allUserRoles;
    } catch (error) {
      showApolloError(error);
    }
  }
}